import { useState } from 'react';

import styles from '../../SchemePage.module.scss';

const PdfViewer = ({ documentLink }: { documentLink: string }) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className={styles.holderDoc}>
      <div className={styles.holderImg}>
        {isLoading && <span>Идет загрузка...</span>}
        <img
          src={documentLink}
          alt="scheme img"
          onLoad={handleImageLoad}
          style={{ display: isLoading ? 'none' : 'inline' }}
        />
      </div>
    </div>
  );
};

export default PdfViewer;
